/**
 * Helper to make commonly used rules like
 * required and url
 */
export const makeRules =
    (requiredFields: string[]) =>
    (name: string, isUrl: boolean = false) => {
        const rules: { [key: string]: any }[] = [
            {
                required: requiredFields.includes(name),
            },
        ];
        if (isUrl) {
            rules.push({
                type: 'url',
            });
        }
        return rules;
    };
